import { useState, useCallback } from 'react';
import useAsyncEffect from 'use-async-effect';
import { useNavigate } from 'react-router-dom';

import { useMytaverseEvent } from '@core/dashboard/providers';
import { useMytaverse } from '@providers/MytaverseProvider';
import { sendCustomSentryBreadcrumb } from '@helpers/sentry';

import { IAvatar } from '@interfaces/avatar';

import ROUTES from '@constants/routes';
import { env } from 'env';

const { REACT_APP_FEATURE_AVATARS_CUSTOM } = env;

const useEventAvatars = () => {
  const navigate = useNavigate();

  const { currentEventId, currentEvent } = useMytaverseEvent();
  const { setCurrentAvatarId } = useMytaverse();

  const [eventAvatars, setEventAvatars] = useState<IAvatar[]>([]);
  const [loadingAvatars, setLoadingAvatars] = useState(true);

  const handleChoseAvatar = useCallback(
    (avatar: IAvatar) => {
      const { avatarId } = avatar;

      sendCustomSentryBreadcrumb({ message: 'select avatar' });
      localStorage.setItem('avatarId', avatarId);
      setCurrentAvatarId(avatarId);
      navigate(ROUTES.SELECT_AVATAR_SKIN(currentEventId));
    },
    [currentEventId],
  );

  useAsyncEffect(async () => {
    if (!currentEvent || REACT_APP_FEATURE_AVATARS_CUSTOM !== 'true') {
      return;
    }

    setLoadingAvatars(true);

    setEventAvatars(currentEvent.avatars);

    setLoadingAvatars(false);
  }, [currentEventId, currentEvent]);

  return { loadingAvatars, eventAvatars, handleChoseAvatar };
};

export default useEventAvatars;
